import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function FlipIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 7H0V9H16V7Z" />
        <path d="M12 5H4V0L12 5Z" />
        <path d="M12 11H4V16L12 11Z" />
      </svg>
    </Icon>
  );
}
